// AutoMapper
import "reflect-metadata";
import {
    AutoMapper,
    ProfileBase,
    mapFrom,
    Mapper,
    convertUsing,
    Converter
} from "@nartc/automapper";

// Models
import { PartyGenderDto } from 'app/_mapper/partygender.dto';
import { PartyGenderVm } from 'app/_mapper/partygender.vm';

export class PartyGenderProfile extends ProfileBase {
    constructor(mapper: AutoMapper) {
        super();

        mapper
            .createMap(PartyGenderDto, PartyGenderVm);
            
        mapper
            .createMap(PartyGenderVm, PartyGenderDto);
    }
}